import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Units from './components/Units';
import Testimonials from './components/Testimonials';
import InstagramFeed from './components/InstagramFeed';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFab from './components/WhatsAppFab';

const Home = () => (
  <div className="bg-ink text-cream min-h-screen relative overflow-hidden">
    <Navbar />
    <Hero />
    <About />
    <Features />
    <Units />
    <Testimonials />
    <InstagramFeed />
    <Contact />
    <Footer />
    <WhatsAppFab />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
